import { Component, ElementRef, Inject, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';

import * as fa from '@fortawesome/free-solid-svg-icons';
import { Organization } from 'src/app/classes/organization';

import { AuthService } from 'src/app/shared/auth.service';
import { environment } from 'src/environments/environment';
import Locales from 'src/app/constants/locales';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {

  fa = fa
  organizations: Organization[] = []
  environment = environment
  locales = Locales

  signupForm = new FormGroup({
    organization_name: new FormControl('', [Validators.required]),
    first_name: new FormControl('', [Validators.required]),
    last_name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    mobile_phone: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
    confirm_password: new FormControl('', [Validators.required]),
  })

  constructor(
    private router: Router,
    public authService: AuthService,
    @Inject(LOCALE_ID) public activeLocale: string) {}
  
    language() {
    document.cookie = `admin_lang=${this.activeLocale};max-age=${365 * 24 * 60 * 60};path=/`;
    window.location.href = `/${ environment.base_url ? environment.base_url : '' }${this.activeLocale}/signup`
  }

  ngOnInit(): void {
    
  }

  signup() {
    this.authService.signup(this.signupForm.value)
  }
}
